/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useCallback } from "react"

import { useDropzone } from "react-dropzone"

import { useAITranslatorSettingsLocal } from "./use-ai-translator-settings-local"
import { defaultSettings } from "../constants/translator-defaults"

export function useTranslationDictionary() {
  const { settings, updateSettings } = useAITranslatorSettingsLocal()

  const customTranslations = settings.customTranslations ?? defaultSettings.customTranslations

  function addCustomTranslation() {
    const newTranslations = [...customTranslations, { original: "", translation: "" }]
    updateSettings({ customTranslations: newTranslations })
  }

  function handleDeleteCustomTranslation(index: number) {
    const newTranslations = customTranslations.filter((_: unknown, i: number) => i !== index)
    updateSettings({ customTranslations: newTranslations })
  }

  function handleChangeCustomTranslation(
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) {
    const name = event.target.name
    const newTranslations = customTranslations.map(
      (t: { original: string; translation: string }, i: number) =>
        i === index ? { ...t, [name]: event.target.value } : t
    )
    updateSettings({ customTranslations: newTranslations })
  }

  const onDropAccepted = useCallback(
    (acceptedFiles: File[]) => {
      const reader = new FileReader()

      reader.onload = () => {
        const customTranslationsData: Record<string, string> = JSON.parse(reader.result as string)
        const newCustomTranslations = Object.entries(customTranslationsData).map(
          ([original, translation]) => ({
            original,
            translation,
          })
        )
        updateSettings({ customTranslations: newCustomTranslations })
      }

      reader.readAsText(acceptedFiles[0])
    },
    [updateSettings]
  )

  const {
    acceptedFiles,
    getInputProps,
    open: openFileSelector,
  } = useDropzone({
    onDropAccepted,
    noDrag: true,
    maxFiles: 1,
    preventDropOnDocument: true,
    accept: {
      "application/json": [".json"],
    },
  })

  return {
    customTranslations,
    addCustomTranslation,
    handleDeleteCustomTranslation,
    handleChangeCustomTranslation,
    acceptedFiles,
    getInputProps,
    openFileSelector,
  }
}
